import { render, staticRenderFns } from "./MainProductsSettings.vue?vue&type=template&id=587281cb&scoped=true&"
import script from "./MainProductsSettings.vue?vue&type=script&lang=js&"
export * from "./MainProductsSettings.vue?vue&type=script&lang=js&"
import style0 from "./MainProductsSettings.vue?vue&type=style&index=0&id=587281cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587281cb",
  null
  
)

export default component.exports